import type { AssetTypePageTabsProps } from "./asset-type-page-tabs.type";
import type { TabViewItem } from "@/ui/tab-view";

import { useTranslation } from "react-i18next";

import { TAB_KEYS } from "@/constants/TabKeys";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { AppSaveBar } from "@/modules/app-save-bar";
import AssetTypeDetailsTab from "@/modules/asset-type/asset-type-details-tab";
import {
  ASSET_TYPE_SEVERITY_GRID_SCOPE,
  AssetTypeSeverityGridTab,
} from "@/modules/asset-type/asset-type-severity-grid-tab";
import { TabView } from "@/ui/tab-view";

export const AssetTypePageTabs = ({
  assetType,
  loading,
}: AssetTypePageTabsProps) => {
  const { t } = useTranslation();
  const isFeatureSeverityGridEditorOn = useFeatureFlag("dev2579");

  const tabs: TabViewItem[] = [
    {
      key: TAB_KEYS.TEMPLATE_DETAILS,
      label: t("global:details"),
      children: <AssetTypeDetailsTab assetType={assetType} />,
    },
    {
      key: TAB_KEYS.TEMPLATE_SEVERITY_GRID,
      label: t("form:severityGridEditor.title"),
      children: (
        <AssetTypeSeverityGridTab assetType={assetType} loading={loading} />
      ),
      hidden: !isFeatureSeverityGridEditorOn,
    },
  ];

  return (
    <TabView
      isNav
      tabs={tabs}
      tabBarExtraContent={
        <AppSaveBar
          scope={ASSET_TYPE_SEVERITY_GRID_SCOPE}
          tabs={[TAB_KEYS.TEMPLATE_SEVERITY_GRID]}
          date={assetType?.updated_at}
          loading={loading}
        />
      }
    />
  );
};
